import React from "react";
import styles from "../PropertySelector.module.scss";
import classnames from "classnames";
import { Tooltip } from "~/components/tooltip/Tooltip";
import chroma from "chroma-js";
import { isPropertyEnabled, translatePropertyValue } from "../propertyCore";
import CheckboxPropertySelectorWrapper from "./common/CheckboxPropertySelectorWrapper";

export default function CheckboxColorPropertySelector(props) {
    const { appProps, exchangeAlternatives, selectedProperties, selectedPropertyValue, propertyValues, propertyType, onSelectedPropertyValue } = props;

    return (
        <CheckboxPropertySelectorWrapper {...props}>
            {propertyValues.map(({ value: propertyValue, hexColor }) => {
                let selected = selectedPropertyValue === propertyValue;
                let disabled = !isPropertyEnabled({
                    exchangeAlternatives,
                    propertyType,
                    propertyTypeChoices: selectedProperties,
                    propertyValue: propertyValue,
                });

                const text = translatePropertyValue({ ...props, propertyValue: propertyValue });

                const isColorLight = chroma(hexColor).luminance() > 0.82;
                return (
                    <div key={propertyValue}>
                        <Tooltip
                            content={
                                <div>
                                    {text}
                                    {disabled && <span>: {appProps?.getLocaleText("out-of-stock")}</span>}
                                </div>
                            }
                        >
                            <div className={classnames(styles["color-property-selector"], selected && styles["color-property-selected"], disabled && styles["color-property-disabled"])}>
                                {disabled && <div className={styles["color-property-disabled-icon"]} />}
                                <div
                                    className={classnames(styles["color-property-inner"], disabled && styles["color-property-disabled"], isColorLight && styles["color-property-inner-light"])}
                                    onClick={disabled ? undefined : () => onSelectedPropertyValue({ propertyValue: propertyValue })}
                                    style={{ backgroundColor: hexColor }}
                                ></div>
                            </div>
                        </Tooltip>
                    </div>
                );
            })}
        </CheckboxPropertySelectorWrapper>
    );
}
